<template>
  <div class="home">
    <menuBox :step="1"></menuBox>
    <div class="banner-box" id="home" ref="home">
      <div class="banner-text">
        <div class="title">
          Haga coincidir rápidamente productos financieros
        </div>
        <!-- <div class="subtitle">kesejahteraan, kesehatan, pekerjaan</div> -->
        <div class="text">
          Las recomendaciones inteligentes facilitan la búsqueda de la solución
          financiera ideal a corto y largo plazo. aprende más
        </div>
        <!-- <div class="btn" @click="goPage()">Hubungi kami</div> -->
      </div>
    </div>
    <div class="mission-box">
      <div class="mission-list">
        <div class="mission-item">
          <img src="../assets/mission-icon-1.png" alt="" />
          <div class="mission-title">
            Recomendación inteligente
          </div>
          <div class="mission-content">
            Utilice algoritmos únicos para satisfacer con precisión las
            necesidades de los usuarios y los productos financieros.
          </div>
        </div>
        <div class="mission-item">
          <img src="../assets/mission-icon-2.png" alt="" />
          <div class="mission-title">
            Instituciones cooperantes
          </div>
          <div class="mission-content">
            Coopere con varias instituciones financieras autorizadas para
            garantizar el cumplimiento y la seguridad del producto.
          </div>
        </div>
        <div class="mission-item">
          <img src="../assets/mission-icon-3.png" alt="" />
          <div class="mission-title">
            Fácil de usar
          </div>
          <div class="mission-content">
            Interfaz de usuario sencilla y amigable, proceso rápido de solicitud
            y aprobación.
          </div>
        </div>
        <div class="mission-item">
          <img src="../assets/mission-icon-4.png" alt="" />
          <div class="mission-title">
            Seguridad
          </div>
          <div class="mission-content">
            Se toman estrictas medidas de protección de la privacidad para
            garantizar la seguridad de los datos del usuario.
          </div>
        </div>
      </div>
      <div class="mission-msg">
        <img class="msg" src="../assets/mission-msg.png" alt="" />
        <div class="msg-box">
          <div class="msg-title">
            ¿Por qué elegirnos?
          </div>
          <div class="msg-content">
            A través de su avanzado algoritmo de recomendación inteligente, Crédito Ágil es capaz de relacionar de
            manera rápida y precisa a los usuarios con los productos financieros más adecuados, ya sean necesidades de
            préstamos a corto o largo plazo. La estrecha cooperación con muchas instituciones financieras autorizadas
            garantiza la seguridad y el cumplimiento de todos los productos recomendados. Al mismo tiempo, la interfaz
            de usuario simple y fácil de usar y las potentes medidas de protección de datos garantizan la comodidad de
            la experiencia del usuario y la seguridad de la información personal. Convirtiéndolo en una herramienta
            ideal de selección de productos financieros.
            aprende más
          </div>
          <!-- <div class="btn" @click="goPage()">
            Hubungi kami
          </div> -->
        </div>
        <img class="process" src="../assets/process.png" alt="" />
      </div>
    </div>
    <div class="business-box">
      <img class="title-img" src="../assets/Frame.png" alt="" />
      <div class="b-content">
        Desde que utilizamos Crédito Ágil, encontrar el producto crediticio adecuado se ha vuelto extremadamente fácil.
        Las recomendaciones inteligentes son realmente precisas, fáciles de operar y la información se siente segura.
        Las instituciones cooperativas también son instituciones bien conocidas, lo cual es tranquilizador.
      </div>
      <img class="user" src="../assets/user.png" alt="" />
      <div class="user-info">Linda</div>
      <div class="user-name">
        Actualmente abriendo una cafetería.
      </div>
    </div>

    <div class="partner-box">
      <div class="p-title">¿Qué les importa a los usuarios?</div>
      <!-- <div class="p-subtitle">
        Bagaimana cara mendapatkan dukungan finansial?
      </div> -->
      <div class="partner-list">
        <div class="item">
          <div class="tit">
            <span>1 </span>¿Cómo garantizar la seguridad de mis datos?
          </div>
          <div class="msg">
            Respuesta: **Crédito Ágil utiliza tecnología de cifrado de datos líder en la industria y estrictas políticas
            de protección de privacidad para garantizar que la información personal y los datos de transacciones de los
            usuarios estén seguros y no se filtren.
          </div>
        </div>
        <div class="item">
          <div class="tit">
            <span>2 </span>¿Es complicado el proceso de solicitud?
          </div>
          <div class="msg">
            Respuesta: **No, Crédito Ágil se compromete a brindar un servicio fácil de usar con un proceso de solicitud
            simplificado que le permita completar su solicitud en unos pocos pasos simples y recibir comentarios
            rápidos.
          </div>
        </div>
        <div class="item">
          <div class="tit">
            <span>3 </span>¿Puedo reembolsar el préstamo por adelantado?
          </div>
          <div class="msg">
            Respuesta: **Sí, Crédito Ágil admite el pago anticipado sin cobrar cargos adicionales. Los usuarios pueden
            elegir de manera flexible un plan de pago según su situación financiera.
          </div>
        </div>
        <div class="item">
          <div class="tit"><span>4 </span>¿Cómo elegir el producto financiero que más me conviene?</div>
          <div class="msg">
            Respuesta: **El sistema de recomendación inteligente de Crédito Ágil buscará los productos financieros más
            adecuados para usted según su situación y necesidades financieras, eliminando la necesidad de comparación
            manual, ahorrando tiempo y energía.
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="deveopment-box">
      <div class="d-title">Development Goals</div>
      <div class="d-content">
        Embark on a journey of innovation with AZALEA TECH, where our
        development goal is to redefine the technological landscape. We aspire
        to be at the forefront of fearless innovation, transforming digital
        experiences globally. Our commitment extends to empowering businesses,
        leading in sustainable technology, and cultivating a diverse and
        talented team. Together, we collaborate for a global impact, creating a
        future where possibilities are limitless. Join us in shaping tomorrow's
        potential at AZALEA TECH.
      </div>
    </div> -->
    <div class="del-data-box">
      <div class="tel-box" v-if="steps == 1">
        <div class="tip">
          Al utilizar la función de eliminación de datos, para la seguridad de sus datos, usted
          necesita verificar su identidad
        </div>
        <div class="title">Por favor, introduzca su número de móvil</div>
        <input v-model="mobile" type="text" class="tel-in" placeholder="Por favor introduce un número de teléfono" />
        <input v-model="password" type="password" class="tel-pa"
          placeholder="Por favor ingrese la contraseña de la APLICACIÓN" />
        <div class="btn" @click="delSearch">Próximo paso</div>
      </div>
      <div class="tel-box" v-else-if="steps == 2">
        <div class="text-box">
          Querido usuario
          <br />
          ¡Hola! Muchas gracias por elegir utilizar la APP CréditoÁgil. <br />
          Antes de solicitar la eliminación de la cuenta, confirma todos tus pedidos
          se ha completado y no hay pedidos bajo revisión. Necesidad
          Tenga en cuenta que una vez que se elimina una cuenta, los datos no se pueden recuperar.
          Confirme cuidadosamente antes de operar. Esta aplicación no
          responsable de cualquier daño que ocurra a la propiedad
          personal. <br />
          Si has confirmado que deseas eliminar tus datos, por favor hazlo
          haga clic en el botón de abajo.
        </div>
        <div class="btn" @click="candelete">Confirmar eliminación</div>
      </div>

      <div class="tel-box" v-else-if="steps == 3">
        <div class="title">
          Por favor ingrese el código de verificación para verificar su identidad
        </div>
        <div class="iump-box">
          <input v-model="code" type="text" class="car-in tel-in"
            placeholder="Por favor ingresa el código de verificación de 4 dígitos" />
          <div class="count-btn" @click="Reenviar">
            {{ Time <= 0 ? "reenviar" : Time }} </div>
          </div>
          <div class="btn" @click="doDelete">Bueno</div>
        </div>

        <div class="tel-box del-box" v-else-if="steps == 4">
          <img src="../assets/del.png" alt="" />
          <p>¡Tus datos han sido eliminados!</p>
        </div>
        <div class="tel-box" v-else-if="steps == 5">
          <div class="title">verificación de tarjeta de identidad</div>
          <input v-model="idcard" type="text" class="tel-in"
            placeholder="Por favor ingrese su número de identificación" />
          <div class="btn" @click="verifyIdCard">Inspeccionar</div>
        </div>
      </div>
      <div class="flex-box" v-if="msgDlg">
        <div class="msg-box">
          <div class="msg">
            <img src="../assets/title-err.png" class="err-img" />
            {{ msg }}
          </div>
          <img src="../assets/close.png" class="close" @click="msgDlg = false" />
        </div>
      </div>
      <footerBox ref="footerBox"></footerBox>
    </div>
</template>

<script>
  import footerBox from "@/components/footer";
  import menuBox from "@/components/menu";
  import * as api from "@/api/api";
  export default {
    name: "App",
    components: {
      menuBox,
      footerBox,
    },
    data() {
      return {
        show: false,
        mobile: "",
        password: "",
        code: "",
        msgDlg: false,
        msg: "",
        steps: 1,
        infoData: {},
        Time: 0,
        idcard: "",
        verifyIDCard: "",
      };
    },
    mounted() { },
    methods: {
      goPage() {
        this.$refs.footerBox.selectMenu(5);
      },
      delSearch() {
        let data = {
          mobile: this.mobile,
          password: this.password,
        };

        if (!this.mobile) {
          this.msgDlg = true;
          this.msg = "El número de celular no puede estar vacío.";
          return;
        }
        if (!this.password) {
          this.msgDlg = true;
          this.msg = "La contraseña es obligatoria.";
          return;
        }

        console.log(this.$loading);
        let loding = this.$loading.show({});
        api
          .delInfoSearch(data)
          .then((res) => {
            loding.hide();
            this.infoData = res.data;
            this.steps = 2;
          })
          .catch((e) => {
            loding.hide();
            this.msgDlg = true;
            this.msg = e.message;
          });
      },
      candelete() {
        let data = {
          user_id: this.infoData.user_id,
        };
        let loding = this.$loading.show({});
        api
          .delInfoCanDelete(data)
          .then((res) => {
            loding.hide();
            if (res.data.idcard) {
              this.verifyIDCard = res.data.idcard;
              this.steps = 5;
            } else {
              this.steps = 3;
              this.Reenviar();
            }
          })
          .catch((e) => {
            loding.hide();
            this.msgDlg = true;
            this.msg = e.message;
          });
      },
      verifyIdCard() {
        console.log(this.verifyIDCard);
        if (this.verifyIDCard == this.idcard) {
          this.steps = 3;
          this.Reenviar();
        } else {
          this.msgDlg = true;
          this.msg = "La tarjeta de identificación se ingresó incorrectamente y la verificación falló.";
        }
      },
      Reenviar() {
        if (this.Time > 0) {
          return;
        }
        this.Countdown(60);
        let data = {
          mobile: this.mobile,
        };
        let loding = this.$loading.show({});
        api
          .delInfoSms(data)
          .then((res) => {
            loding.hide();
          })
          .catch((e) => {
            loding.hide();
            this.msgDlg = true;
            this.msg = e.message;
          });
      },
      doDelete() {
        let loding = this.$loading.show({});
        let data = {
          mobile: this.mobile,
          code: this.code,
          user_id: this.infoData.user_id,
        };
        api
          .delInfoDoDelete(data)
          .then((res) => {
            loding.hide();
            this.steps = 4;
          })
          .catch((e) => {
            loding.hide();
            this.msgDlg = true;
            this.msg = e.message;
          });
      },
      Countdown(time) {
        this.Time = time;
        if (time <= 0) {
          return;
        }

        setTimeout(() => {
          this.Countdown(time - 1);
        }, 1000);
      },
    },
  };
</script>

<style lang="less" scoped>
  .banner-box {
    background-image: url(../assets/swiper-1.png);
    height: 600px;
    background-size: 100% 100%;
    position: relative;

    .banner-text {
      margin-left: 360px;
      padding-top: 165px;
      width: 700px;
      text-align: center;

      .title {
        font-size: 36px;
        font-family: Inter, Inter;
        font-weight: normal;
        color: #ce3723;

        span {
          color: #333333;
        }
      }

      .subtitle {
        font-size: 32px;
        font-family: Inter, Inter;
        font-weight: normal;
        color: #1e1e1e;
      }

      .btn {
        width: 136px;
        height: 44px;
        text-align: center;
        line-height: 44px;
        font-size: 16px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        background: #ce3723;
        border-radius: 30px;
        margin: auto;
        margin-top: 16px;
      }

      .text {
        font-size: 16px;
        font-family: Inter, Inter;
        font-weight: 400;
        color: #959595;
        margin-top: 16px;
        padding: 0 10px;
      }
    }
  }

  .mission-box {
    padding: 0 360px;
    background: #f2f2f2;
    padding-bottom: 100px;

    .mission-list {
      height: 450px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .mission-item {
        background-color: #fff;
        width: 250px;
        height: 226px;
        text-align: center;

        img {
          width: 60px;
          height: 60px;
          margin-top: -25px;
        }

        .mission-title {
          font-size: 20px;
          font-family: Inter, Inter;
          font-weight: normal;
          color: #1e1e1e;
          margin-top: 12px;
        }

        .mission-content {
          font-size: 14px;
          font-family: Inter, Inter;
          font-weight: 400;
          color: #959595;
          line-height: 16px;
          margin-top: 24px;
          padding: 0 20px;
        }
      }
    }

    .mission-msg {
      height: 300px;
      background-color: #fff;

      .msg {
        height: 100%;
        float: left;
      }

      .process {
        float: left;
        width: 180px;
        height: 180px;
        margin-top: 57px;
        margin-left: 30px;
      }

      .msg-box {
        margin-left: 40px;
        max-width: 580px;
        float: left;

        .msg-title {
          font-size: 20px;
          font-family: Inter, Inter;
          font-weight: normal;
          color: #1e1e1e;
          line-height: 24px;
          margin-top: 20px;
        }

        .msg-content {
          font-size: 14px;
          font-family: Inter, Inter;
          font-weight: 400;
          color: #959595;
          line-height: 16px;
          margin-top: 16px;
        }

        .btn {
          width: 136px;
          height: 44px;
          text-align: center;
          line-height: 44px;
          font-size: 16px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          background: #ce3723;
          border-radius: 30px;
          margin-top: 20px;
        }
      }
    }
  }

  .user-serve-box {
    margin-top: 100px;
    background-image: url(../assets/swiper-3.png);
    height: 627px;
    overflow: hidden;
    background-size: 100% 100%;

    .title {
      font-size: 32px;
      width: 660px;
      font-family: Roboto-Bold, Roboto;
      font-weight: bold;
      color: #333333;
      text-align: left;
      margin-left: 900px;
      margin-top: 40px;
    }

    .subtitle {
      font-size: 26px;
      margin-top: 24px;
      text-align: center;
      font-weight: 500;
      color: #999999;
    }

    .server-list-box {
      margin-left: 900px;
      text-align: left;
      margin-top: 34px;

      .tit {
        font-size: 24px;
        font-family: Roboto-Regular, Roboto;
        font-weight: 400;
        color: #333333;
      }

      .item {
        font-size: 20px;
        font-family: Roboto-Regular, Roboto;
        font-weight: 400;
        color: #999999;
        margin-top: 20px;

        img {
          width: 16px;
          height: 16px;
        }
      }
    }
  }

  .business-box {
    background-image: url(../assets/swiper-2.png);
    height: 410px;
    overflow: hidden;
    background-size: 100% 100%;
    text-align: center;

    .title-img {
      width: 80px;
      height: 80px;
      margin-top: 33px;
    }

    .b-content {
      font-size: 14px;
      font-family: Inter, Inter;
      font-weight: 400;
      color: #ffffff;
      line-height: 18px;
      padding: 0 360px;
      margin-top: 36px;
    }

    .user {
      width: 70px;
      height: 70px;
      margin-top: 30px;
      border-radius: 50%;
    }

    .user-info {
      font-size: 14px;
      font-family: Inter, Inter;
      font-weight: 500;
      color: #ffffff;
      line-height: 16px;
      margin-top: 8px;
    }

    .user-name {
      font-size: 12px;
      font-family: Inter, Inter;
      font-weight: 400;
      color: #ffffff;
      line-height: 14px;
      margin-top: 8px;
    }
  }

  .partner-box {
    padding: 80px 360px;
    text-align: center;
    padding-bottom: 50px;

    .p-title {
      font-size: 32px;
      font-family: Inter, Inter;
      font-weight: normal;
      color: #1e1e1e;
      line-height: 38px;
    }

    .p-subtitle {
      font-size: 16px;
      font-family: Inter, Inter;
      font-weight: 500;
      color: #ce3723;
      line-height: 19px;
      margin-top: 13px;
    }

    .partner-list {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      margin-top: 35px;

      .item:nth-child(odd) {
        margin-right: 70px;
      }

      .item {
        width: 550px;
        text-align: left;

        margin-bottom: 35px;

        .tit {
          font-size: 20px;
          font-family: Inter, Inter;
          font-weight: 500;
          color: #1e1e1e;
          line-height: 24px;

          span {
            color: #ce3723;
          }
        }

        .msg {
          font-size: 14px;
          font-family: Inter, Inter;
          font-weight: 400;
          color: #959595;
          line-height: 16px;
          margin-top: 18px;
        }
      }
    }
  }

  .deveopment-box {
    padding: 0 360px;
    height: 650px;
    overflow: hidden;
    background: linear-gradient(#fde2e2, #fffbef);

    .d-title {
      font-size: 48px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      text-align: center;
      margin-top: 100px;
      margin-bottom: 24px;
    }

    .d-content {
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
    }
  }
  .del-data-box {
	background: #fff;
  border-top: 1px solid #333;
	padding: 100px 360px;
	margin-top: 50px;
	color: #333;
	.tel-box {
	  min-height: 155px;
	  padding: 40px 150px;
	  display: flex;
	  flex-direction: column;
	  align-items: center;
  
	  .tip {
		font-size: 16px;
		font-weight: 400;
	  }
  
	  .title {
		font-size: 24px;
		font-weight: 400;
		margin: 0px;
		margin-top: 24px;
	  }
  
	  .tel-in,
	  .tel-pa {
		width: 452px;
		height: 60px;
		border-radius: 5px;
		border: 1px solid #EFEFEF;
		margin-top: 14px;
		padding: 0px 24px;
		font-size: 16px;
		font-weight: 400;
		color: #333333;
		line-height: 60px;
	  }
  
	  .iump-box {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-top: 24px;
		width: 500px;
	  }
  
	  .car-in {
		width: 302px;
		margin: 0;
	  }
  
	  .btn {
		width: 452px;
		height: 60px;
		padding: 0px 24px;
		background: #ce3723;
		border-radius: 5px;
		font-size: 16px;
		font-weight: 400;
		color: #FFFFFF;
		text-align: center;
		line-height: 60px;
		margin-top: 24px;
		cursor: pointer;
	  }
  
	  .count-btn {
		width: 120px;
		height: 60px;
		border-radius: 8px;
		border: 1px solid #EFEFEF;
		line-height: 60px;
		font-size: 16px;
		font-weight: 400;
		color: #333;
		text-align: center;
		cursor: pointer;
	  }
  
	  .text-box {
		font-size: 16px;
		font-weight: 400;
		color: #333;
	  }
	}
  
	.del-box {
	  display: flex;
	  align-items: center;
	  flex-direction: column;
	  justify-content: center;
  
	  img {
		width: 97px;
	  }
  
	  p {
		font-size: 16px;
		font-weight: 400;
		margin-top: 24px;
	  }
	}
  }
  .flex-box {
	position: fixed;
	left: 0px;
	top: 0px;
	width: 100%;
	height: 100%;
	background: fade(#000, 90%);
	display: flex;
	align-items: center;
	justify-content: center;
    z-index: 111;
	.msg-box {
	  position: relative;
  
	  .err-img {
		width: 100px;
		margin-top: -100px;
	  }
  
	  .msg {
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		background: #fff;
		text-align: center;
		color: #999;
		font-size: 26px;
		padding: 50px;
		width: 380px;
		border-radius: 17px;
  
	  }
  
	  .close {
		position: absolute;
		right: 10px;
		top: 10px;
		width: 30px;
	  }
	}
  }
</style>